import { input } from '@angular/core';
import { InstructionOutletComponent, SimpleFieldsetComponent } from '@common/forms/frontend-shared';
import { DynamicComponentDirective } from '@core/frontend-shared';
import { ItemModel, ModelCtor } from '@core/shared/model';
import { takeWhileAlive } from '@core/frontend-shared/utils';
import { BehaviorSubject, combineLatest, filter, switchMap } from 'rxjs';
import { NgTemplateOutlet, AsyncPipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
const _c0 = (a0, a1, a2, a3, a4, a5, a6) => ({
  formGroup: a0,
  formService: a1,
  model: a2,
  editMode: a3,
  restraints: a4,
  crudItemViewService: a5,
  extraData: a6
});
function CrudFieldsetComponent_Conditional_0_Conditional_1_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudFieldsetComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, CrudFieldsetComponent_Conditional_0_Conditional_1_ng_container_1_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.innerForm)("ngTemplateOutletContext", i0.ɵɵpureFunction7(2, _c0, ctx_r1.formService.formGroup, ctx_r1.formService, ctx_r1.formService.formGroup.getRawValue(), ctx_r1.formService.editMode, ctx_r1.formService.restraints, ctx_r1.crudItemViewService(), ctx_r1.innerFormData));
  }
}
function CrudFieldsetComponent_Conditional_0_Conditional_2_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function CrudFieldsetComponent_Conditional_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, CrudFieldsetComponent_Conditional_0_Conditional_2_ng_container_0_Template, 1, 0, "ng-container", 4);
  }
  if (rf & 2) {
    i0.ɵɵproperty("dynamicComponent", ctx);
  }
}
function CrudFieldsetComponent_Conditional_0_Conditional_3_For_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "instruction-outlet", 5);
  }
  if (rf & 2) {
    const instruction_r3 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("instruction", instruction_r3)("formService", ctx_r1.formService);
  }
}
function CrudFieldsetComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵrepeaterCreate(1, CrudFieldsetComponent_Conditional_0_Conditional_3_For_2_Template, 1, 2, "instruction-outlet", 5, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("formGroup", ctx_r1.formService.formGroup);
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx);
  }
}
function CrudFieldsetComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵlistener("keyup.enter", function CrudFieldsetComponent_Conditional_0_Template_div_keyup_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEnter($event));
    })("keyup.control.enter", function CrudFieldsetComponent_Conditional_0_Template_div_keyup_control_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onEnter($event));
    });
    i0.ɵɵconditionalCreate(1, CrudFieldsetComponent_Conditional_0_Conditional_1_Template, 2, 10, "div");
    i0.ɵɵconditionalCreate(2, CrudFieldsetComponent_Conditional_0_Conditional_2_Template, 1, 1, "ng-container");
    i0.ɵɵconditionalCreate(3, CrudFieldsetComponent_Conditional_0_Conditional_3_Template, 3, 1, "div", 2);
    i0.ɵɵpipe(4, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_2_0;
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.innerForm ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_2_0 = ctx_r1.innerFormComponentConfig()) ? 2 : -1, tmp_2_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_3_0 = i0.ɵɵpipeBind1(4, 3, ctx_r1.allInstructions$)) ? 3 : -1, tmp_3_0);
  }
}
function CrudFieldsetComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 6);
    i0.ɵɵlistener("click", function CrudFieldsetComponent_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.showDebug());
    });
    i0.ɵɵtext(1, "Debug Form");
    i0.ɵɵelementEnd();
  }
}
export let CrudFieldsetComponent = /*#__PURE__*/(() => {
  class CrudFieldsetComponent extends SimpleFieldsetComponent {
    constructor() {
      super(...arguments);
      // NOTE: no required input because many custom uses of <crud-fieldset> dont specify it
      this.crudItemViewService = input(null, ...(ngDevMode ? [{
        debugName: "crudItemViewService"
      }] : /* istanbul ignore next */[]));
      // in CrudFieldset, instructions may change per ItemEditMode.
      // so incoming CrudInstructionsDefinition may be an Instruction[] or a map of ItemEditMode to Instruction[]!
      this.crudInstructions$ = new BehaviorSubject(null);
      this.nullProp = combineLatest({
        editMode: this.editMode$,
        crudInstructions: this.crudInstructions$
      }).pipe(takeWhileAlive()).subscribe(({
        editMode,
        crudInstructions
      }) => {
        if (!crudInstructions) {
          this.directInstructions$.next(null);
        } else {
          const instructions = !Array.isArray(crudInstructions) ? editMode ? crudInstructions[editMode] : null : crudInstructions;
          this.directInstructions$.next(instructions);
        }
      });
    }
    set _crudInstructions(instructions) {
      this.crudInstructions$.next(instructions);
    }
    get editMode() {
      return this.formService.getEditMode();
    }
    get editMode$() {
      return this.formService$.pipe(filter(fs => !!fs), switchMap(fs => fs.getEditMode$()));
    }
    getPluginInstructions(ModelConstructor) {
      return this.pluginInstructionsService.getPluginInstructions(ModelConstructor, this.contextGroups || undefined, this.formService.getEditorDefinition(), this.editMode // TODO: should this be based on Observable? 
      );
    }
    setupInnerFormComponent(formService, cmp) {
      const config = super.setupInnerFormComponent(formService, cmp);
      config.inputs.crudItemViewService = this.crudItemViewService;
      return config;
    }
    _executeInitialization(options = {}) {
      super._executeInitialization(options);
    }
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵCrudFieldsetComponent_BaseFactory;
        return function CrudFieldsetComponent_Factory(__ngFactoryType__) {
          return (ɵCrudFieldsetComponent_BaseFactory || (ɵCrudFieldsetComponent_BaseFactory = i0.ɵɵgetInheritedFactory(CrudFieldsetComponent)))(__ngFactoryType__ || CrudFieldsetComponent);
        };
      })();
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: CrudFieldsetComponent,
        selectors: [["crud-fieldset"]],
        inputs: {
          crudItemViewService: [1, "crudItemViewService"],
          _crudInstructions: [0, "instructions", "_crudInstructions"]
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        decls: 3,
        vars: 4,
        consts: [[1, "debug-btn"], [3, "keyup.enter", "keyup.control.enter"], [1, "form-fields", 3, "formGroup"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "dynamicComponent"], [3, "instruction", "formService"], [1, "debug-btn", 3, "click"]],
        template: function CrudFieldsetComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵconditionalCreate(0, CrudFieldsetComponent_Conditional_0_Template, 5, 5, "div");
            i0.ɵɵconditionalCreate(1, CrudFieldsetComponent_Conditional_1_Template, 2, 0, "button", 0);
            i0.ɵɵpipe(2, "async");
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.initialized && ctx.formService.initialized ? 0 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(i0.ɵɵpipeBind1(2, 2, ctx.showDebugButton$) ? 1 : -1);
          }
        },
        dependencies: [NgTemplateOutlet, DynamicComponentDirective, FormsModule, i1.NgControlStatusGroup, ReactiveFormsModule, i1.FormGroupDirective, InstructionOutletComponent, AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:block;flex:1;height:auto;position:relative}[_nghost-%COMP%] > div[_ngcontent-%COMP%]{flex:1;height:auto}.custom-form[_ngcontent-%COMP%]{flex:1;height:auto;display:flex;flex-direction:column}.form-fields[_ngcontent-%COMP%] > *[_ngcontent-%COMP%] + *[_ngcontent-%COMP%]{margin-top:10px;display:block}.custom-form[_ngcontent-%COMP%] + .form-fields[_ngcontent-%COMP%]{margin-top:10px}.debug-btn[_ngcontent-%COMP%]{position:absolute;top:0;right:0}\n\n/*# sourceMappingURL=crud-fieldset.component.ts-angular-inline--30.css.map*/"]
      });
    }
  }
  return CrudFieldsetComponent;
})();